// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  color: var(--color-card-text);
  border: none;
}

.item-selection-section {
  margin-top: 20px;
  margin-bottom: 20px;
}
.item-selection-section .info-address {
  font-size: medium;
  margin-top: 5%;
  font-weight: 600;
  border: none;
  color: var(--color-interaction-text);
  background-color: rgba(0, 0, 0, 0);
}

.hide {
  display: none;
}

input[type=radio] + .fa,
input[type=radio] + label > .fa {
  cursor: pointer;
}

.title {
  margin-left: 12px;
  font-weight: 600;
}

.body {
  font-size: 16px;
  font-weight: 400;
  margin-left: 4px;
}

.form-control {
  border: none;
  border-bottom: 2px solid var(--color-primary);
  background-color: rgba(0, 0, 0, 0);
  color: var(--color-card-text);
}

.form-control:disabled,
.form-control[readonly] {
  background-color: rgba(0, 0, 0, 0);
}

.label-text {
  font-weight: 600;
  margin-bottom: 0px;
}

input.form-control {
  height: 45px;
  border-radius: 0px;
}

.input-group {
  width: 72%;
}

.form-group {
  margin-top: 5%;
}
.form-group i {
  border-bottom: 2px solid var(--color-primary);
  padding-top: 10%;
  font-size: 10px;
}

.form-group label + input.form-control {
  padding-top: 20px;
}

.tab-color {
  color: #495057;
}

.details {
  border-bottom: 1px solid var(--color-secondary);
}

.delivery-options {
  display: inline-grid;
}
.delivery-options .list {
  padding-top: 20px;
}
.delivery-options .list .details {
  margin-right: 5px;
}
.delivery-options .list .semi-bold {
  font-weight: 600;
}
.delivery-options .list-items {
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 12px;
}
.delivery-options .info-text {
  margin-top: 12px;
  margin-bottom: 12px;
}
.delivery-options .image {
  width: 100%;
  margin-top: 12px;
}
.delivery-options .margin-top {
  margin-top: 12px;
}

select {
  border: none;
  border-bottom: 2px solid var(--color-primary);
  height: 45px;
  width: 71%;
}

.is-invalid {
  border-bottom: 2px solid var(--color-error);
}

.address {
  margin-bottom: 3%;
}
.address span {
  font-weight: 600;
}

.head {
  border-bottom: 1px solid var(--color-primary);
  padding-bottom: 5px;
  padding-top: 5px;
  font-weight: 600;
}

.collectionpoint {
  padding-top: 10px;
}
.collectionpoint .showaddress {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  color: var(--color-primary);
}

.fa-stack {
  width: 22px;
  height: 22px;
  margin: -3px 0px 0px 0px;
}

.fa-stack .fa-stack-2x {
  font-size: 20px;
  line-height: 22px;
  color: var(--color-primary);
}

.fa-stack .fa-stack-1x {
  line-height: 22.7px;
}

.warning {
  max-width: 45px;
  margin: 30px 5px 0px 0px;
  color: #4f4f4f;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/delivery-options/delivery-options.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AACF;;AACA;EACE,gBAAA;EACA,mBAAA;AAEF;AAAE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,kCAAA;AAEJ;;AAEA;EACE,aAAA;AACF;;AACA;;EAEE,eAAA;AAEF;;AAAA;EACE,iBAAA;EACA,gBAAA;AAGF;;AADA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAIF;;AAAA;EACE,YAAA;EACA,6CAAA;EACA,kCAAA;EACA,6BAAA;AAGF;;AADA;;EAEE,kCAAA;AAIF;;AADA;EACE,gBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,YAAA;EACA,kBAAA;AAKF;;AAHA;EACE,UAAA;AAMF;;AAJA;EACE,cAAA;AAOF;AANE;EACE,6CAAA;EACA,gBAAA;EACA,eAAA;AAQJ;;AALA;EACE,iBAAA;AAQF;;AALA;EACE,cAAA;AAQF;;AANA;EACE,+CAAA;AASF;;AAPA;EACE,oBAAA;AAUF;AATE;EACE,iBAAA;AAWJ;AAVI;EACE,iBAAA;AAYN;AAVI;EACE,gBAAA;AAYN;AATE;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAWJ;AARE;EACE,gBAAA;EACA,mBAAA;AAUJ;AARE;EACE,WAAA;EACA,gBAAA;AAUJ;AARE;EACE,gBAAA;AAUJ;;AAPA;EACE,YAAA;EACA,6CAAA;EACA,YAAA;EACA,UAAA;AAUF;;AARA;EACE,2CAAA;AAWF;;AATA;EACE,iBAAA;AAYF;AAXE;EACE,gBAAA;AAaJ;;AAVA;EACE,6CAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAaF;;AAXA;EACE,iBAAA;AAcF;AAbE;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAeJ;;AAXA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;AAcF;;AAZA;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;AAeF;;AAbA;EACE,mBAAA;AAgBF;;AAdA;EACE,eAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AAiBF","sourcesContent":[".card {\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  color: var(--color-card-text);\n  border: none;\n}\n.item-selection-section {\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n  .info-address {\n    font-size: medium;\n    margin-top: 5%;\n    font-weight: 600;\n    border: none;\n    color: var(--color-interaction-text);\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n\n.hide {\n  display: none;\n}\ninput[type=\"radio\"] + .fa,\ninput[type=\"radio\"] + label > .fa {\n  cursor: pointer;\n}\n.title {\n  margin-left: 12px;\n  font-weight: 600;\n}\n.body {\n  font-size: 16px;\n  font-weight: 400;\n  margin-left: 4px;\n}\n// stack\n\n.form-control {\n  border: none;\n  border-bottom: 2px solid var(--color-primary);\n  background-color: rgba(0, 0, 0, 0);\n  color: var(--color-card-text);\n}\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.label-text {\n  font-weight: 600;\n  margin-bottom: 0px;\n}\ninput.form-control {\n  height: 45px;\n  border-radius: 0px;\n}\n.input-group {\n  width: 72%;\n}\n.form-group {\n  margin-top: 5%;\n  i {\n    border-bottom: 2px solid var(--color-primary);\n    padding-top: 10%;\n    font-size: 10px;\n  }\n}\n.form-group label + input.form-control {\n  padding-top: 20px;\n}\n\n.tab-color {\n  color: #495057;\n}\n.details {\n  border-bottom: 1px solid var(--color-secondary);\n}\n.delivery-options {\n  display: inline-grid;\n  .list {\n    padding-top: 20px;\n    .details {\n      margin-right: 5px;\n    }\n    .semi-bold {\n      font-weight: 600;\n    }\n  }\n  .list-items {\n    margin-left: 16px;\n    margin-right: 16px;\n    margin-top: 12px;\n  }\n\n  .info-text {\n    margin-top: 12px;\n    margin-bottom: 12px;\n  }\n  .image {\n    width: 100%;\n    margin-top: 12px;\n  }\n  .margin-top {\n    margin-top: 12px;\n  }\n}\nselect {\n  border: none;\n  border-bottom: 2px solid var(--color-primary);\n  height: 45px;\n  width: 71%;\n}\n.is-invalid {\n  border-bottom: 2px solid var(--color-error);\n}\n.address {\n  margin-bottom: 3%;\n  span {\n    font-weight: 600;\n  }\n}\n.head {\n  border-bottom: 1px solid var(--color-primary);\n  padding-bottom: 5px;\n  padding-top: 5px;\n  font-weight: 600;\n}\n.collectionpoint {\n  padding-top: 10px;\n  .showaddress {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 16px;\n    color: var(--color-primary);\n  }\n}\n\n.fa-stack {\n  width: 22px;\n  height: 22px;\n  margin: -3px 0px 0px 0px;\n}\n.fa-stack .fa-stack-2x {\n  font-size: 20px;\n  line-height: 22px;\n  color: var(--color-primary);\n}\n.fa-stack .fa-stack-1x {\n  line-height: 22.7px;\n}\n.warning {\n  max-width: 45px;\n  margin: 30px 5px 0px 0px;\n  color: #4f4f4f;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
